export const examPaperData = {
  title: "New English",
  durationSeconds: 45 * 60,
  questions: [
    {
      id: "q1",
      type: "mcq",
      prompt: "The seasonal contrasts are maximum in ________",
      options: [
        "Low latitudes",
        "Mid-latitudes",
        "Sub tropical margins",
        "Polar ocean belts",
      ],
      correctAnswer: "Mid-latitudes",
    },
    {
      id: "q2",
      type: "descriptive",
      prompt: "What is the name of our Universe?",
      placeholder: "Type your answer here...",
      modelAnswer:
        "The name of our universe is the Milky Way galaxy's universe, commonly referred to simply as the Universe.",
    },
    {
      id: "q3",
      type: "mcq",
      prompt: "Which layer of the atmosphere contains most weather events?",
      options: ["Troposphere", "Mesosphere", "Thermosphere", "Exosphere"],
      correctAnswer: "Troposphere",
    },
    {
      id: "q4",
      type: "mcq",
      prompt: "The process by which plants prepare food is called ________",
      options: ["Respiration", "Photosynthesis", "Transpiration", "Digestion"],
      correctAnswer: "Photosynthesis",
    },
    {
      id: "q5",
      type: "descriptive",
      prompt: "Write two reasons why clean water is important for human life.",
      placeholder: "Write your response...",
      modelAnswer:
        "Clean water is important because it prevents disease and helps the body carry out essential functions like digestion and temperature control.",
    },
    {
      id: "q6",
      type: "mcq",
      prompt: "Which number is a prime number?",
      options: ["21", "27", "29", "33"],
      correctAnswer: "29",
    },
    {
      id: "q7",
      type: "mcq",
      prompt: "The capital city of Japan is ________",
      options: ["Kyoto", "Osaka", "Tokyo", "Nagoya"],
      correctAnswer: "Tokyo",
    },
    {
      id: "q8",
      type: "descriptive",
      prompt: "Explain the difference between renewable and non-renewable energy.",
      placeholder: "Type your explanation...",
      modelAnswer:
        "Renewable energy comes from sources that can be naturally replenished, such as solar and wind, while non-renewable energy comes from limited sources such as coal and petroleum.",
    },
    {
      id: "q9",
      type: "mcq",
      prompt: "Which organ pumps blood through the human body?",
      options: ["Lungs", "Brain", "Heart", "Liver"],
      correctAnswer: "Heart",
    },
    {
      id: "q10",
      type: "mcq",
      prompt: "What is 15% of 200?",
      options: ["20", "25", "30", "35"],
      correctAnswer: "30",
    },
    {
      id: "q11",
      type: "mcq",
      prompt: "Which of these is a mammal?",
      options: ["Shark", "Dolphin", "Octopus", "Trout"],
      correctAnswer: "Dolphin",
    },
    {
      id: "q12",
      type: "descriptive",
      prompt: "Describe one good habit that helps students learn effectively.",
      placeholder: "Type your answer...",
      modelAnswer:
        "A good study habit is reviewing lessons regularly and taking short notes, because it improves understanding and long-term memory.",
    },
    {
      id: "q13",
      type: "mcq",
      prompt: "Which fraction is equal to one half?",
      options: ["2/3", "3/6", "4/5", "5/8"],
      correctAnswer: "3/6",
    },
    {
      id: "q14",
      type: "mcq",
      prompt: "The largest planet in the solar system is ________",
      options: ["Earth", "Jupiter", "Saturn", "Mars"],
      correctAnswer: "Jupiter",
    },
    {
      id: "q15",
      type: "descriptive",
      prompt: "State one effect of deforestation on the environment.",
      placeholder: "Type your answer...",
      modelAnswer:
        "Deforestation can cause habitat loss, soil erosion, and increased carbon dioxide in the atmosphere.",
    },
    {
      id: "q16",
      type: "mcq",
      prompt: "Which angle is greater than 90 degrees but less than 180 degrees?",
      options: ["Acute angle", "Right angle", "Obtuse angle", "Reflex angle"],
      correctAnswer: "Obtuse angle",
    },
    {
      id: "q17",
      type: "mcq",
      prompt: "Which nutrient is mainly used by the body for growth and repair?",
      options: ["Protein", "Fat", "Water", "Fibre"],
      correctAnswer: "Protein",
    },
    {
      id: "q18",
      type: "descriptive",
      prompt: "Write a short note on why recycling is important.",
      placeholder: "Type your note...",
      modelAnswer:
        "Recycling is important because it reduces waste, saves natural resources, and lowers pollution by reusing materials instead of discarding them.",
    },
    {
      id: "q19",
      type: "mcq",
      prompt: "Which of the following is a keyboard input device?",
      options: ["Monitor", "Printer", "Mouse", "Keyboard"],
      correctAnswer: "Keyboard",
    },
    {
      id: "q20",
      type: "mcq",
      prompt: "Which sentence is written in the past tense?",
      options: [
        "She sings every day.",
        "She will sing tomorrow.",
        "She sang yesterday.",
        "She is singing now.",
      ],
      correctAnswer: "She sang yesterday.",
    },
  ],
};
